import { render } from "./App.vue?vue&type=template&id=1586171a"
const script = {}
script.render = render

export default script